import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BsFillChatDotsFill } from "react-icons/bs";
import RechargePopup from "./RechargePopup";
import { HOST_URL, NODE_HOST_URL_v1 } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";
import {
  faAlignJustify,
  faUser,
  faEnvelope,
  faCode,
  faAtom,
  faLink,
  faDownload,
  faImage,
  faIcons,
  faCommentDots,
  faBriefcase,
  faSortNumericUpAlt,
  faPaperPlane,
  faAddressBook,
  faFileAlt,
  faSignInAlt,
  faTasks,
  faList,
  faListAlt,
  faShieldAlt,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FiFileText, FiShield, FiBarChart2, FiCheck, FiX, FiZap, FiLock } from "react-icons/fi";
import logoUrl from "../Dashboard/assets/img/logo.png";
import DashboardLogo from "../Dashboard/assets/img/DashboardLogo.png";
import smsIcon from "../Dashboard/assets/img/chat-bubbles-with-ellipsis.png";
import fallbackIcon from "../Dashboard/assets/img/awesome-scroll.png";
import analyticsIcon from "../Dashboard/assets/img/analytics.png";
import phoneIcon from "../Dashboard/assets/img/phone1.png";
import microphoneIcon from "../Dashboard/assets/img/microphone.png";
import whatsapp from "../Dashboard/assets/img/whatsapp.png";
import feedbackImg from "../Dashboard/assets/img/side-bar.png";
import { WhstappAccountList } from "../Dashboard/api/Api";
import { checkUserUrl } from "../Utils/Utils";
import ChooseCampaign from "./campaign/ChooseCampaign";
import { MdMms } from "react-icons/md";
import RcsBlackImage from "../Dashboard/assets/img/rcsBlackImage-removebg-preview.png";
import { userProfile } from "../Dashboard/api/Api";

const DashboardLeftMenu = (props) => {
  const CCSLDS = [
    "co.in",
    "co.uk",
    "com.au",
    "co.nz",
    "co.za",
    "com.br",
    "net.in",
    "org.in",
  ];

  const extractDomain = (host) => {
    const hostname = host.split(":")[0];
    const parts = hostname.split(".");
    const lastTwo = parts.slice(-2).join(".");
    if (CCSLDS.includes(lastTwo) && parts.length > 3) {
      return parts.slice(-3).join(".");
    }
    if (parts.length > 2) {
      return parts.slice(-2).join(".");
    }
    return hostname;
  };

  const domain = extractDomain(window.location.host);
  const [menuId, setMenuId] = useState("sidebar");
  const [pName, setPName] = useState("");
  const [menuActive, setMenuActive] = useState(false);
  const [settings, setSettings] = useState(null);
  const [parent_id, setParent_id] = useState(null);
  const [campaignAllowed, setCampaignAllowed] = useState(false);
  const [showRechargePopup, setShowRechargePopup] = useState(false);
  const [addedBy, setAddedBy] = useState(null);
  const [widgetAnalyticsEnabled, setWidgetAnalyticsEnabled] = useState(false);
  const [showWidgetPopup, setShowWidgetPopup] = useState(false);

  const lStorage = JSON.parse(localStorage.getItem("login"));

  const adminStorage = JSON.parse(localStorage.getItem("admin")) || null;
  const empStorage = JSON.parse(localStorage.getItem("emp")) || null;

  const parent_type = lStorage?.user?.parent_type;

  const userID = lStorage?.user?.userId;
  const sms_menu = lStorage?.user?.sms_menu === 0 ? false : true;
  const voice_menu = lStorage?.user?.voice_menu === 0 ? false : true;
  const email_menu = lStorage?.user?.email_menu === 0 ? false : true;
  const whatsapp_menu = lStorage?.user?.whatsapp_menu === 0 ? false : true;
  const chat_menu = lStorage?.user?.chat_menu === 0 ? false : true;
  const camp_menu = lStorage?.user?.camp_menu === 0 ? false : true;
  const fb_menu = lStorage?.user?.fb_menu === 0 ? false : true;
  const rcs_menu = lStorage?.user?.rcs_menu === 0 ? false : true;
  const flow_menu = lStorage?.user?.flow_menu === 0 ? false : true;
  const rich_menu = lStorage?.user?.rich_menu === 0 ? false : true;
  const url = lStorage?.url;
  const send_wp_single = lStorage?.user?.send_wp_single;

  useEffect(() => {
    const storedSettings = localStorage.getItem("siteSettings");

    if (storedSettings) {
      const parsedSettings = JSON.parse(storedSettings);
      setSettings(parsedSettings);
    }
  }, []);

  useEffect(() => {
    const loginData = localStorage.getItem("login");

    if (!loginData) return;

    const { user, token } = JSON.parse(loginData);
    let paramData = {
      user_id: lStorage.user.userId,
      token: lStorage.token,
      method: "retrieve",
    };
    userProfile(paramData).then((result) => {
      if (result?.data?.success === true) {
        const profile = result.data.data[0];
        setParent_id(profile.parent);

        const addedByNormalized = profile.added_by
          ? profile.added_by.trim().toLowerCase()
          : "";
        setAddedBy(addedByNormalized);

        if (addedByNormalized !== "startup india") {
          setCampaignAllowed(true);

          return;
        }
        fetch(
          `${HOST_URL}/transaction_history.php?user_id=${user.userId}&method=retrieve_paid&token=${token}`,
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.success === true) {
              setCampaignAllowed(true);
            } else {
              setCampaignAllowed(false);
            }
          })
          .catch((err) => {
            console.error("API error:", err);
          });
      }
    });
  }, []);

  useEffect(() => {
    fetchUserPlans();
  }, []);

  const fetchUserPlans = async () => {
    try {
      const { data } = await Axios.post(`${NODE_HOST_URL_v1}/plans`, {
        user_id: lStorage?.user?.userId,
        token: lStorage?.token,
        method: "fetchUserEnabledPlans",
      });
      if (data.success && data.data?.length > 0) {
        const hasWidgetAnalytics = data.data.some(
          (p) => p.plan_title === "Widget Analytics" && !p.is_expired
        );
        setWidgetAnalyticsEnabled(hasWidgetAnalytics);
      }
    } catch (error) {
      setWidgetAnalyticsEnabled(false);
    }
  };

  // useEffect(() => {
  //   userProfile().then((result) => {
  //     if (result.data.success === true) {
  //       setParent_id(result.data.data[0].parent);
  //     }
  //   })
  // }, []);

  useEffect(() => {
    let paramData = {
      user_id: lStorage?.user?.userId,
      method: "retrieve",
      token: lStorage?.token,
    };
    WhstappAccountList(paramData).then((res) => {
      // localStorage.setItem("wp-cmpy-name", res.data.data[0].comp_name);
      // localStorage.setItem("wp-cmpy-img", res.data.data[0].image_url);
      // localStorage.setItem(
      //   "wp-cmpy-brand_number",
      //   res.data.data[0].brand_number
      // );

      if (res.data.data === undefined) {
        setMenuActive(false);
      } else {
        setMenuActive(true);
      }
    });
  }, []);

  const checkActive = (match, location) => {
    if (!location) return false;
    const { pathname } = location;
    setPName(pathname);
  };

  // ORM section active check
  const isInstagramSection =
    pName === "/dashboard/instagram" || pName === "/dashboard/instagram-report";
  const isInstagramActive = pName === "/dashboard/instagram";       // exact match only
  const isInstagramReportActive = pName === "/dashboard/instagram-report";

  const isFacebookSection = pName === "/dashboard/facebook";
  const isOrmSection = isInstagramSection || isFacebookSection;

  const handleCampaignClick = (e) => {
    if (!campaignAllowed && addedBy === "startup india") {
      e.preventDefault();
      setShowRechargePopup(true);
    }
  };

  const menuHideShow = () => {
    if (menuId === "sidebar") {
      setMenuId("sidebar collapsed");
      document.body.classList.add("sidebar-collapsed"); //  add this
    } else {
      setMenuId("sidebar");
      document.body.classList.remove("sidebar-collapsed"); //  remove it

    }
  };

  const loginAgentAuthkey = () => {
    const loginData = localStorage.getItem("login");
    const parsedData = JSON.parse(loginData);

    const newTabUrl = `https://agent.${domain}/?authkey=${parsedData?.user?.authkey_parent}`;

    window.open(newTabUrl, "_blank");
  };

  const loginFlow = () => {
    const loginData = localStorage.getItem("login");
    const parseDate = JSON.parse(loginData);

    const newTabUrl = `https://flow.${domain}/login-with-console?authkey=${parseDate?.user?.authkey_parent}`;

    window.open(newTabUrl, "_blank");
  };

  return (
    <>
      <nav id="sidebar" className={menuId}>
        <div
          className="sidebar-content js-simplebar"
          style={{
            background: "#f8f8f8",
            position: "sticky",
            top: 0,
            left: 0,
            height: "100vh",
            margin: "0px",

            zIndex: 1000,
          }}
        >
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1000,

              background: "#f8f8f8",
            }}
          >
            <Link className="sidebar-brand" to="/dashboard">
              {checkUserUrl(url) === true ? (
                <img className="Logo" alt="logo" src={logoUrl} />
              ) : settings?.dashboard_logo ? (
                <img
                  className="Logo1"
                  alt="logo"
                  src={settings?.dashboard_logo}
                />
              ) : (
                <img className="Logo" alt="logo" src={DashboardLogo} />
              )}
            </Link>

            <span onClick={menuHideShow} className="sidebar-toggle d-flex">
              <i className="hamburger align-self-center"></i>
            </span>

            <ul className="sidebar-nav">
              <li className="sidebar-header"></li>

              <li
                className={
                  pName === "/dashboard"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <NavLink
                  className="sidebar-link"
                  isActive={checkActive}
                  to="/dashboard"
                >
                  <FontAwesomeIcon icon={faAlignJustify} />{" "}
                  <span className="align-middle">Dashboard</span>
                </NavLink>
              </li>
            </ul>
          </div>
          <div
            style={{
              overflowY: "auto",
              flexGrow: 1,
              height: "100vh",
            }}
          >
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              {checkUserUrl(url) && parent_id !== 10774 && (
                <li
                  style={{ background: "#10222dba" }}
                  className="sidebar-link"
                >
                  <NavLink
                    style={{ color: "#61dafb", padding: "0px 0px" }}
                    to="/dashboard/api-docs"
                  >
                    <FontAwesomeIcon
                      style={{ color: "#61dafb" }}
                      icon={faCode}
                    />{" "}
                    <span className="align-middle">API Docs</span>
                  </NavLink>
                </li>
              )}

              {sms_menu && (
                <li
                  className={
                    pName === "/dashboard/send-sms" ||
                      pName === "/dashboard/dlt-template-list" ||
                      pName === "/dashboard/add-entity-id" ||
                      pName === "/dashboard/sms-template-list" ||
                      pName === "/dashboard/sms-report" ||
                      pName === "/dashboard/sms-api-docs" ||
                      pName === "/dashboard/sms-price-list" ||
                      pName === "/dashboard/optout" ||
                      pName.includes(
                        "/sms-template/edit/" || "/dashboard/template-management",
                      ) ||
                      pName === "/dashboard/sms-template"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a
                    href="#sms"
                    data-target="#sms"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <img className="dashboardIcons" alt="icons" src={smsIcon} />{" "}
                    <span className="align-middle"> SMS </span>
                  </a>
                  <ul
                    id="sms"
                    className={
                      pName === "/dashboard/send-sms" ||
                        pName.includes("/sms-template/edit/") ||
                        pName === "/dashboard/dlt-template-list" ||
                        pName === "/dashboard/add-entity-id" ||
                        pName === "/dashboard/sms-template-list" ||
                        pName === "/dashboard/sms-api-docs" ||
                        pName === "/dashboard/sms-report" ||
                        pName === "/dashboard/sms-price-list" ||
                        pName === "/dashboard/optout" ||
                        pName === "/dashboard/sms-template"
                        ? "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    <li
                      className={
                        pName === "/dashboard/send-sms"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link className="sidebar-link" to="/dashboard/send-sms">
                        Send SMS{" "}
                      </Link>
                    </li>

                    <li
                      className={
                        pName === "/dashboard/sms-template-list" ||
                          pName.includes("/sms-template/edit/") ||
                          pName === "/dashboard/sms-template"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <a
                        className="sidebar-link"
                        href="/dashboard/sms-template-list"
                      >
                        {" "}
                        Template
                      </a>
                    </li>

                    <li
                      className={
                        pName === "/dashboard/sms-api-docs"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/sms-api-docs"
                      >
                        API Docs
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/sms-price-list"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/sms-price-list"
                      >
                        Pricing{" "}
                      </Link>
                    </li>

                    <li>
                      <a
                        href="#dltsetup"
                        data-target="#dltsetup"
                        data-toggle="collapse"
                        className="sidebar-link collapsed"
                      >
                        <span className="align-middle"> DLT Setup </span>
                      </a>
                      <ul
                        id="dltsetup"
                        className={
                          pName === "/dashboard/add-entity-id" ||
                            pName === "/dashboard/dlt-template-list"
                            ? "sidebar-dropdown list-unstyled collapse show"
                            : "sidebar-dropdown list-unstyled collapse"
                        }
                      >
                        <li
                          className={
                            pName === "/dashboard/add-entity-id"
                              ? "sidebar-item active"
                              : "sidebar-item"
                          }
                        >
                          <Link
                            className="sidebar-link"
                            to="/dashboard/add-entity-id"
                          >
                            Entity Management
                          </Link>
                        </li>

                        <li
                          className={
                            pName === "/dashboard/dlt-template-list" ||
                              pName === "/dashboard/sms-template"
                              ? "sidebar-item active"
                              : "sidebar-item"
                          }
                        >
                          <Link
                            className="sidebar-link"
                            to="/dashboard/dlt-template-list"
                          >
                            {" "}
                            Template Management{" "}
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/sms-report"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link className="sidebar-link" to="/dashboard/sms-report">
                        Report
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/optout"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link className="sidebar-link" to="/dashboard/optout">
                        Optout
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {voice_menu && (
                <li
                  className={
                    pName === "/dashboard/send-voice" ||
                      pName === "/dashboard/voice-template-list" ||
                      pName === "/dashboard/voice-template-list" ||
                      pName === "/dashboard/voice-report" ||
                      pName === "/dashboard/flash-call" ||
                      pName === "/dashboard/voice-template" ||
                      pName === "/dashboard/caller-id" ||
                      pName === "/dashboard/voice-api-docs" ||
                      pName === "/dashboard/manage-tts" ||
                      pName === "/dashboard/tts-create-group" ||
                      pName === "/dashboard/tts-upload-clip"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a
                    href="#Voice"
                    data-target="#Voice"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <img
                      className="dashboardIcons"
                      alt="icons"
                      src={microphoneIcon}
                    />{" "}
                    <span className="align-middle"> Voice </span>
                  </a>
                  <ul
                    id="Voice"
                    className={
                      pName === "/dashboard/send-voice" ||
                        pName === "/dashboard/voice-price-list" ||
                        pName === "/dashboard/caller-id" ||
                        pName === "/dashboard/voice-template-list" ||
                        pName === "/dashboard/voice-report" ||
                        pName === "/dashboard/flash-call" ||
                        pName === "/dashboard/voice-template" ||
                        pName === "/dashboard/voice-api-docs" ||
                        pName === "/dashboard/manage-tts" ||
                        pName === "/dashboard/tts-create-group" ||
                        pName === "/dashboard/tts-upload-clip"
                        ? "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    <li
                      className={
                        pName === "/dashboard/send-voice"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link className="sidebar-link" to="/dashboard/send-voice">
                        Send Voice{" "}
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/voice-template-list" ||
                          pName === "/dashboard/voice-template"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/voice-template-list"
                      >
                        {" "}
                        Template
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/voice-api-docs"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/voice-api-docs"
                      >
                        {" "}
                        Voice API{" "}
                      </Link>
                    </li>

                    {/* <li className={pName === '/dashboard/caller-id' ? 'sidebar-item active' : 'sidebar-item'}><Link className="sidebar-link" to="/dashboard/caller-id"> Caller ID </Link></li> */}

                    <li
                      className={
                        pName === "/dashboard/voice-price-list"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/voice-price-list"
                      >
                        {" "}
                        Pricing{" "}
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/voice-report"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/voice-report"
                      >
                        Report
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/flash-call"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link className="sidebar-link" to="/dashboard/flash-call">
                        Flash Call
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/manage-tts" ||
                          pName === "/dashboard/tts-create-group" ||
                          pName === "/dashboard/tts-upload-clip"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <a
                        href="#ManageTTS"
                        data-toggle="collapse"
                        data-target="#ManageTTS"
                        className="sidebar-link collapsed"
                      >
                        Manage TTS
                      </a>
                      <ul
                        id="ManageTTS"
                        className={
                          pName === "/dashboard/manage-tts" ||
                            pName === "/dashboard/tts-create-group" ||
                            pName === "/dashboard/tts-upload-clip"
                            ? "sidebar-dropdown list-unstyled collapse show"
                            : "sidebar-dropdown list-unstyled collapse"
                        }
                      >
                        <li
                          className={
                            pName === "/dashboard/tts-create-group"
                              ? "sidebar-item active"
                              : "sidebar-item"
                          }
                        >
                          <Link
                            className="sidebar-link"
                            to="/dashboard/tts-create-group"
                          >
                            Create Group
                          </Link>
                        </li>
                        <li
                          className={
                            pName === "/dashboard/tts-upload-clip"
                              ? "sidebar-item active"
                              : "sidebar-item"
                          }
                        >
                          <Link
                            className="sidebar-link"
                            to="/dashboard/tts-upload-clip"
                          >
                            Upload Clip in Group
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              )}

              {email_menu && (
                <li
                  className={
                    pName === "/dashboard/send-email" ||
                      pName === "/dashboard/email-template-list" ||
                      pName === "/dashboard/email-price" ||
                      pName === "/dashboard/email-api-docs" ||
                      pName === "/dashboard/aws-email-verify" ||
                      pName === "/dashboard/aws-setup" ||
                      pName === "/dashboard/email-template" ||
                      pName === "/dashboard/email-report"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a
                    href="#Email"
                    data-target="#Email"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <FontAwesomeIcon icon={faEnvelope} />{" "}
                    <span className="align-middle"> Email </span>
                  </a>
                  <ul
                    id="Email"
                    className={
                      pName === "/dashboard/send-email" ||
                        pName === "/dashboard/email-validator" ||
                        pName === "/dashboard/email-template-list" ||
                        pName === "/dashboard/email-validator" ||
                        pName === "/dashboard/email-api-docs" ||
                        pName === "/dashboard/email-report" ||
                        pName === "/dashboard/aws-email-verify" ||
                        pName === "/dashboard/aws-setup" ||
                        pName === "/dashboard/email-price" ||
                        pName === "/dashboard/email-campaning-list" ||
                        pName === "/dashboard/email-campaning" ||
                        pName === "/dashboard/email-template"
                        ? "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    <li
                      className={
                        pName === "/dashboard/send-email"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link className="sidebar-link" to="/dashboard/send-email">
                        Send Email{" "}
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/email-template-list" ||
                          pName === "/dashboard/email-template"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/email-template-list"
                      >
                        {" "}
                        Template
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/email-api-docs"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/email-api-docs"
                      >
                        {" "}
                        API Docs{" "}
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/email-validator"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/email-validator"
                      >
                        {" "}
                        Email Validator{" "}
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/email-report"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/email-report"
                      >
                        Report
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/aws-setup"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link className="sidebar-link" to="/dashboard/aws-setup">
                        AWS Setting
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/aws-email-verify"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/aws-email-verify"
                      >
                        Sender Email
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/EmailVerification"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/EmailVerification"
                      >
                        Email Verification
                      </Link>
                    </li>
                    {/* <li>
                    <a
                      href="#emailcampaign"
                      data-target="#emailcampaign"
                      data-toggle="collapse"
                      className="sidebar-link collapsed"
                    >
                      <span className="align-middle"> Email Campaign </span>
                    </a>
                  </li> */}
                  </ul>
                </li>
              )}

              {whatsapp_menu && (
                <li
                  className={
                    pName === "/dashboard/whatsapp" ||
                      pName === "/dashboard/create-whatsapp" ||
                      pName === "/dashboard/whatsapp-onboarding" ||
                      pName === "/dashboard/whatsapp-report" ||
                      pName === "/dashboard/create-whatsapp-template" ||
                      pName === "/dashboard/whatsapp-api-docs" ||
                      pName === "/dashboard/sample-template-library" ||
                      pName === "/dashboard/whatsapp-template-list" ||
                      pName === "/dashboard/whatsapp-gallery" ||
                      pName === "/dashboard/whatsapp-optin-otpout" ||
                      pName === "/dashboard/send-whatsapp" ||
                      pName === "/dashboard/whatsapp-conversation" ||
                      pName === "/dashboard/whatsapp-flow-builder"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a
                    href="#whatsapp"
                    data-target="#whatsapp"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <img
                      className="dashboardIcons"
                      alt="icons"
                      src={whatsapp}
                    />{" "}
                    <span className="align-middle"> WhatsApp </span>
                  </a>
                  <ul
                    id="whatsapp"
                    className={
                      pName === "/dashboard/send-whatsapp-single" ||
                        pName === "/dashboard/whatsapp-onboarding" ||
                        pName === "/dashboard/whatsapp-template-list" ||
                        pName === "/dashboard/whatsapp-report" ||
                        pName === "/dashboard/whatsapp-api-docs" ||
                        pName === "/dashboard/sample-template-library" ||
                        pName === "/dashboard/whatsapp-gallery" ||
                        pName === "/dashboard/send-whatsapp" ||
                        pName === "/dashboard/whatsapp-conversation" ||
                        pName === "/dashboard/create-whatsapp" ||
                        pName === "/dashboard/whatsapp-optin-otpout" ||
                        pName === "/dashboard/agent-list" ||
                        pName === "/dashboard/create-whatsapp-template" ||
                        pName === "/dashboard/whatsapp-flow-builder"
                        ? "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    <li
                      className={
                        pName === "/dashboard/send-whatsapp-single" ||
                          "/dashboard/whatsapp" ||
                          pName === "/dashboard/whatsapp-onboarding"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/send-whatsapp-single"
                      >
                        Send WhatsAPP{" "}
                      </Link>
                    </li>
                    {/* {send_wp_single === 1 && (
                    <li
                      className={
                        pName === "/dashboard/send-whatsapp-single"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/send-whatsapp-single"
                      >
                        Send WhatsAPP Single{" "}
                      </Link>
                    </li>
                  )} */}
                    <li
                      className={
                        pName === "/dashboard/whatsapp" ||
                          pName === "/dashboard/whatsapp-onboarding"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link className="sidebar-link" to="/dashboard/whatsapp">
                        {" "}
                        WhatsApp Onboarding{" "}
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/whatsapp-template-list" ||
                          pName === "/dashboard/create-whatsapp-template"
                          ? "sidebar-item active"
                          : menuActive === true
                            ? "sidebar-item"
                            : "sidebar-item link-disabled"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/whatsapp-template-list"
                      >
                        {" "}
                        WhatsApp Template{" "}
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/whatsapp-report"
                          ? "sidebar-item active"
                          : menuActive === true
                            ? "sidebar-item"
                            : "sidebar-item link-disabled"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/whatsapp-report"
                      >
                        {" "}
                        WhatsApp Report{" "}
                      </Link>
                    </li>
                    {/* <li
                    className={
                      pName === "/dashboard/whatsapp-gallery"
                        ? "sidebar-item active"
                        : menuActive === true
                        ? "sidebar-item"
                        : "sidebar-item link-disabled"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/whatsapp-gallery"
                    >
                      Media Gallery
                    </Link>
                  </li> */}
                    <li
                      className={
                        pName === "/dashboard/whatsapp-optin-otpout"
                          ? "sidebar-item active"
                          : menuActive === true
                            ? "sidebar-item"
                            : "sidebar-item link-disabled"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/whatsapp-optin-otpout"
                      >
                        Optin / Optout
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/whatsapp-conversation"
                          ? "sidebar-item active"
                          : menuActive === true
                            ? "sidebar-item"
                            : "sidebar-item link-disabled"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/whatsapp-conversation"
                      >
                        Whatsapp Conversation
                      </Link>
                    </li>

                    <li
                      className={
                        pName === "/dashboard/whatsapp-api-docs"
                          ? "sidebar-item active"
                          : menuActive === true
                            ? "sidebar-item"
                            : "sidebar-item link-disabled"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/whatsapp-api-docs"
                      >
                        Whatsapp API Docs
                      </Link>
                    </li>

                    <li
                      className={
                        pName === "/dashboard/sample-template-library"
                          ? "sidebar-item active"
                          : menuActive === true
                            ? "sidebar-item"
                            : "sidebar-item link-disabled"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/sample-template-library"
                      >
                        Sample Template library
                      </Link>
                    </li>

                    <li
                      className={
                        pName === "/dashboard/whatsapp-flow-builder"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/whatsapp-flow-builder"
                      >
                        Whastapp Flow Builder
                      </Link>
                    </li>

                    {/* <li>
									<a href="#agent" data-target="#agent" data-toggle="collapse" className="sidebar-link collapsed">
										<span className="align-middle "> Agent Settings  </span>
									</a>
									<ul id="agent" className={pName === '/dashboard/add-wp-agent'  || pName === '/dashboard/wp-agent-list' || pName === '/dashboard/agent-setting' ? 'sidebar-dropdown list-unstyled collapse show' : 'sidebar-dropdown list-unstyled collapse'} >

										<li className={pName === '/dashboard/add-wp-agent' ? 'sidebar-item active' : 'sidebar-item'}><Link className="sidebar-link" to="/dashboard/add-wp-agent">Create Agent</Link></li>

										<li className={pName === '/dashboard/wp-agent-list' ? 'sidebar-item active' : 'sidebar-item'}><Link className="sidebar-link" to="/dashboard/wp-agent-list">Agent List</Link></li>

										<li className={pName === '/dashboard/agent-setting' || pName === '/dashboard/sms-template' ? 'sidebar-item active' : 'sidebar-item'}><Link className="sidebar-link" to="/dashboard/agent-setting">  Hunt Strategy </Link></li>

									</ul>
								</li> */}
                  </ul>
                </li>
              )}


              {/* {rich_menu && (
              <li
                className={
                  pName === "/dashboard/test-rich-media" ||
                    pName === "/dashboard/rich-media-template" ||
                    pName === "/dashboard/rich-media-report" ||
                    pName === "/dashboard/create-rich-media-template"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a
                  href="#rcs"
                  data-target="#richMedia"
                  data-toggle="collapse"
                  className="sidebar-link collapsed"
                >
                  <FontAwesomeIcon icon={faIcons} />{" "}
                  <span className="align-middle"> Rich Media </span>
                </a>
                <ul
                  id="richMedia"
                  className={
                    pName === "/dashboard/test-rich-media" ||
                      pName === "/dashboard/rich-media-template" ||
                      pName === "/dashboard/rich-media-report" ||
                      pName === "/dashboard/create-rich-media-template"
                      ? "sidebar-dropdown list-unstyled collapse show"
                      : "sidebar-dropdown list-unstyled collapse"
                  }
                  data-parent="#sidebar"
                >
                  <li
                    className={
                      pName === "/dashboard/test-rich-media"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/test-rich-media"
                    >
                      {" "}
                      Test Rich Media{" "}
                    </Link>
                  </li>
                  <li
                    className={
                      pName === "/dashboard/rich-media-template" ||
                        pName === "/dashboard/create-rich-media-template"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/rich-media-template"
                    >
                      Rich Media Template
                    </Link>
                  </li>
                  <li
                    className={
                      pName === "/dashboard/rich-media-report"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/rich-media-report"
                    >
                      Rich Media Report
                    </Link>
                  </li>
                </ul>
              </li>
            )} */}

              {rcs_menu && (
                <li
                  className={
                    pName === "/dashboard/create-rcs-template" ||
                      pName === "/dashboard/webhook-report" ||
                      pName === "/dashboard/rcs-template-list" ||
                      pName === "/dashboard/rcs-setting" ||
                      pName === "/dashboard/apply-rcs" ||
                      pName === "/dashboard/rcs-pricing" ||
                      pName === "/dashboard/rcs-agent-list" ||
                      pName === "/dashboard/rcs-reports"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a
                    href="#rcs"
                    data-target="#rcs"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <img
                      alt="RcsImage"
                      className="text-primary mr-2 rcs-logo-image"
                      style={{ fontSize: "2em", color: "black" }}
                      src={RcsBlackImage}
                    />{" "}
                    <span className="align-middle"> RCS </span>
                  </a>
                  <ul
                    id="rcs"
                    className={
                      pName === "/dashboard/rcs-list" ||
                        pName === "/dashboard/create-rcs-template" ||
                        pName === "/dashboard/rcs-template-list" ||
                        pName === "/dashboard/apply-rcs" ||
                        pName === "/dashboard//rcs-setting" ||
                        pName === "/dashboard/rcs-pricing" ||
                        pName === "/dashboard/rcs-agent-list" ||
                        pName === "/dashboard/rcs-onboarding-list" ||
                        pName === "/dashboard/rcs-reports"
                        ? // pName === "/dashboard/rcs-api-docs"
                        "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    <li
                      className={
                        pName === "/dashboard/create-rcs-template" ||
                          pName === "/dashboard/rcs-onboarding-list"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/rcs-onboarding-list"
                      >
                        RCS Onboarding
                      </Link>
                    </li>
                    {/* <li className={pName === '/dashboard/rcs-list' || pName === '/dashboard/apply-rcs' ? 'sidebar-item active' : 'sidebar-item'}><a className="sidebar-link" href="/dashboard/rcs-list">Apply For RCS </a></li> */}
                    <li
                      className={
                        pName === "/dashboard/create-rcs-template" ||
                          pName === "/dashboard/rcs-template-list"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/rcs-template-list"
                      >
                        RCS Template
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/create-rcs-template" ||
                          pName === "/dashboard/rcs-api-docs"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/rcs-api-docs"
                      >
                        RCS API Docs
                      </Link>
                    </li>
                    {/* <li
                      className={
                        pName === "/dashboard/rcs-api-docs"
                          ? "sidebar-item active"
                          : menuActive === true
                            ? "sidebar-item"
                            : "sidebar-item link-disabled"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/rcs-api-docs"
                      >
                        API Docs
                      </Link>
                    </li> */}
                    {/* <li className={pName === '/dashboard/rcs-pricing' ? 'sidebar-item active' : 'sidebar-item'}><a className="sidebar-link" href="/dashboard/rcs-pricing">Pricing</a></li>
                <li className={pName === '/dashboard/rcs-reports' ? 'sidebar-item active' : 'sidebar-item'}><a className="sidebar-link" href="/dashboard/rcs-reports">Report</a></li>
                <li className={pName === '/dashboard/rcs-agent-list' ? 'sidebar-item active' : 'sidebar-item'}><a className="sidebar-link" href="/dashboard/rcs-agent-list">Add RCS Agent</a></li>
                <li className={pName === '/dashboard/pagename' ? 'sidebar-item active' : 'sidebar-item'}><a className="sidebar-link" href="/dashboard/rcs-setting">Setting</a></li> */}
                  </ul>
                </li>)}


              {/* Orm */}
              
              {(userID === 6737) && (
                <li className={isOrmSection ? "sidebar-item active" : "sidebar-item"}>
                  <a
                    href="#orm"
                    data-target="#orm"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <FontAwesomeIcon icon={faShieldAlt} className="dashboardIcons" />{" "}
                    <span className="align-middle">ORM</span>
                  </a>

                  <ul
                    id="orm"
                    className={
                      isOrmSection
                        ? "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    {/* Instagram (level 2) — NOT active, just a toggle */}
                    <li className="sidebar-item">
                      <a
                        href="#instagram"
                        data-target="#instagram"
                        data-toggle="collapse"
                        className="sidebar-link collapsed"
                      >
                        <span className="align-middle">Instagram</span>
                      </a>

                      <ul
                        id="instagram"
                        className={
                          isInstagramSection
                            ? "sidebar-dropdown list-unstyled collapse show"
                            : "sidebar-dropdown list-unstyled collapse"
                        }
                      >
                        <li className={isInstagramActive ? "sidebar-item active" : "sidebar-item"}>
                          <Link className="sidebar-link" to="/dashboard/instagram">
                            Instagram Integration
                          </Link>
                        </li>

                        <li className={isInstagramReportActive ? "sidebar-item active" : "sidebar-item"}>
                          <Link className="sidebar-link" to="/dashboard/instagram-report">
                            Instagram Report
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="sidebar-item">
                      <a
                        href="#facebook"
                        data-target="#facebook"
                        data-toggle="collapse"
                        className="sidebar-link collapsed"
                      >
                        <span className="align-middle">Facebook</span>
                      </a>

                      <ul
                        id="facebook"
                        className={
                          isFacebookSection
                            ? "sidebar-dropdown list-unstyled collapse show"
                            : "sidebar-dropdown list-unstyled collapse"
                        }
                      >
                        <li className={isFacebookSection ? "sidebar-item active" : "sidebar-item"}>
                          <Link className="sidebar-link" to="/dashboard/facebook">
                            Facebook Leads
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              )}

              {(userID === 6737) &&
                            <NavLink
                              className="sidebar-link"
                              isActive={checkActive}
                              to="/admin/cdp-search"
                            >
                              <FontAwesomeIcon icon={faSearch} />{" "}
                              <span className="align-middle">CDP Search</span>
                            </NavLink>}

                            
              {(userID === 10186 || userID === 22051) &&
                <li
                  className={
                    pName === "/dashboard/manage-product" ||
                      pName === "/dashboard/orders" ||
                      pName === "/dashboard/payment-gateway"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a
                    href="#catalougemanagement"
                    data-target="#catalougemanagement"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <img
                      alt="RcsImage"
                      className="text-primary mr-2 rcs-logo-image"
                      style={{ fontSize: "2em", color: "black" }}
                      src={RcsBlackImage}
                    />{" "}
                    <span className="align-middle"> Catalouge Management </span>
                  </a>
                  <ul
                    id="catalougemanagement"
                    className={
                      pName === "/dashboard/manage-product" ||
                        pName === "/dashboard/orders" ||
                        pName === "/dashboard/payment-gateway"
                        ? "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    <li
                      className={
                        pName === "/dashboard/manage-product"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/manage-product"
                      >
                        Manage Product
                      </Link>
                    </li>
                    {/* <li className={pName === '/dashboard/rcs-list' || pName === '/dashboard/apply-rcs' ? 'sidebar-item active' : 'sidebar-item'}><a className="sidebar-link" href="/dashboard/rcs-list">Apply For RCS </a></li> */}
                    <li
                      className={
                        pName === "/dashboard/orders"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/orders"
                      >
                        My Order
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/payment-gateway"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/payment-gateway"
                      >
                        Payment Setup
                      </Link>
                    </li>
                  </ul>
                </li>}



              {/* <li
                className={
                  pName === "/dashboard/catalouge-payment-history"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <NavLink
                  className="sidebar-link"
                  isActive={checkActive}
                  to="/dashboard/catalouge-payment-history"
                >
                  <FontAwesomeIcon icon={faListAlt} />{" "}
                  <span className="align-middle">Payment History</span>
                </NavLink>
              </li> */}

              <li
                className={
                  pName === "/dashboard/api-failed-request"
                    ? "sidebar-item active"
                    : menuActive === true
                      ? "sidebar-item"
                      : "sidebar-item link-disabled"
                }
              >
                <Link
                  className="sidebar-link"
                  to="/dashboard/api-failed-request"
                >
                  <FontAwesomeIcon icon={faListAlt} /> Api Failed Request
                </Link>
              </li>

              {(adminStorage?.success !== false ||
                empStorage?.success !== false) && (
                  <li onClick={loginFlow}>
                    <div className="sidebar-link">
                      <FontAwesomeIcon icon={faSignInAlt} />{" "}
                      <span className="align-middle">Chatbot</span>
                    </div>
                  </li>
                )}

              {chat_menu && (
                <li
                  className={
                    pName === "/dashboard/chat-report" ||
                      pName === "/dashboard/chat-setting" ||
                      pName === "/dashboard/user-management/agent" ||
                      pName === "/dashboard/user-management/manager" ||
                      pName === "/dashboard/user-management/team" ||
                      pName === "/dashboard/chat-setting/tag" ||
                      pName === "/dashboard/agent-login-history"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a
                    href="#ChatMgt"
                    data-target="#ChatMgt"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <span className="dashboardIcons rmove">
                      <BsFillChatDotsFill />
                    </span>
                    <span className="align-middle"> Chat Management </span>
                  </a>
                  <ul
                    id="ChatMgt"
                    className={
                      pName === "/dashboard/chat-report" ||
                        pName === "/dashboard/chat-setting" ||
                        // pName === "/dashboard/user-management/agent" ||
                        pName === "/dashboard/user-management/manager" ||
                        pName === "/dashboard/user-management/team" ||
                        pName === "/dashboard/chat-setting/tag" ||
                        pName === "/dashboard/agent-login-history" ||
                        pName === "/dashboard/agent-billing" ||
                        pName === "/dashboard/whatsapp-widget"
                        ? "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    <li>
                      <div className="sidebar-link" onClick={loginAgentAuthkey}>
                        Go to Agent Dashboard{" "}
                        <FontAwesomeIcon icon={faSignInAlt} />
                      </div>
                    </li>{" "}
                    <li
                      className={
                        pName === "/dashboard/whatsapp-widget"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link collapsed"
                        to="/dashboard/whatsapp-widget"
                      >
                        Whatsapp Widget
                      </Link>
                    </li>
                    {(window.location.host === "console.authkey.io" || window.location.host === "localhost:3000") && (
                    <li
                      className={
                        pName === "/dashboard/widget-analytics"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      {(widgetAnalyticsEnabled || userID === 6737) ? (
                        <Link className="sidebar-link" to="/dashboard/widget-analytics">
                          Widget Analytics
                        </Link>
                      ) : (
                        <span
                          className="sidebar-link"
                          style={{ opacity: 0.5, cursor: "pointer" }}
                          onClick={() => setShowWidgetPopup(true)}
                        >
                          Widget Analytics
                          <span style={{ fontSize: "9px", marginLeft: "5px", background: "#6f42c1", color: "#fff", borderRadius: "4px", padding: "1px 5px", fontWeight: "bold" }}>PRO</span>
                        </span>
                      )}
                    </li>
                    )}
                  </ul>
                </li>
              )}

              {camp_menu && (
                <>
                  <li
                    className={
                      pName === "/dashboard/campaign" ||
                        pName === "/dashboard/campaign-with-filter" ||
                        pName === "/dashboard/campaign-start" ||
                        pName === "/dashboard/sms-campaign" ||
                        pName === "/dashboard/rcs-campaign" ||
                        pName === "/dashboard/schedule-report"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <a
                      href="#Campaign"
                      data-target="#Campaign"
                      data-toggle="collapse"
                      className="sidebar-link collapsed"
                      onClick={handleCampaignClick}
                    >
                      <FontAwesomeIcon icon={faPaperPlane} />{" "}
                      <span className="align-middle"> Campaign </span>
                    </a>
                    {(campaignAllowed || addedBy !== "Startup India") &&
                      !showRechargePopup && (
                        <ul
                          id="Campaign"
                          className={
                            pName === "/dashboard/campaign" ||
                              pName === "/dashboard/sms-campaign-start" ||
                              pName === "/dashboard/campaign-start" ||
                              pName === "/dashboard/sms-campaign" ||
                              pName === "/dashboard/rcs-campaign" ||
                              pName === "/dashboard/schedule-report"
                              ? "sidebar-dropdown list-unstyled collapse show"
                              : "sidebar-dropdown list-unstyled collapse"
                          }
                          data-parent="#sidebar"
                        >
                          <li
                            className={
                              pName === "/dashboard/campaign-start" ||
                                pName === "/dashboard/sms-campaign-start" ||
                                pName === "/dashboard/sms-campaign" ||
                                pName === "/dashboard/rcs-campaign"
                                ? "sidebar-item active"
                                : "sidebar-item"
                            }
                          >
                            <Link
                              className="sidebar-link"
                              to="/dashboard/campaign-start"
                            >
                              Create Campaign{" "}
                            </Link>
                          </li>
                          <li
                            className={
                              pName === "/dashboard/campaign"
                                ? "sidebar-item active"
                                : "sidebar-item"
                            }
                          >
                            <Link
                              className="sidebar-link"
                              to="/dashboard/campaign"
                            >
                              {" "}
                              Campaign Report{" "}
                            </Link>
                          </li>
                          <li
                            className={
                              pName === "/dashboard/schedule-report"
                                ? "sidebar-item active"
                                : "sidebar-item"
                            }
                          >
                            <Link
                              className="sidebar-link"
                              to="/dashboard/schedule-report"
                            >
                              {" "}
                              Schedule Campaign{" "}
                            </Link>
                          </li>
                        </ul>
                      )}
                    {showRechargePopup && <RechargePopup />}
                  </li>
                </>
              )}

              <li
                className={
                  pName === "/dashboard/create-contact-list" ||
                    pName === "/dashboard/contact-list" ||
                    pName === "/dashboard/facebook-leads"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a
                  href="#contactData"
                  data-target="#contactData"
                  data-toggle="collapse"
                  className="sidebar-link collapsed"
                >
                  <FontAwesomeIcon icon={faAddressBook} />{" "}
                  <span className="align-middle"> Contact List </span>
                </a>
                <ul
                  id="contactData"
                  className={
                    pName === "/dashboard/create-contact-list" ||
                      pName === "/dashboard/contact-list" ||
                      pName === "/dashboard/facebook-leads"
                      ? "sidebar-dropdown list-unstyled collapse show"
                      : "sidebar-dropdown list-unstyled collapse"
                  }
                  data-parent="#sidebar"
                >
                  <li
                    className={
                      pName === "/dashboard/contact-list" ||
                        pName === "/dashboard/create-contact-list"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link className="sidebar-link" to="/dashboard/contact-list">
                      Contact List
                    </Link>
                  </li>
                  {parent_id !== 10774 && (
                    <li
                      className={
                        pName === "/dashboard/facebook-leads"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/facebook-leads"
                      >
                        Facebook Leads
                      </Link>
                    </li>
                  )}
                </ul>
              </li>

              <li
                className={
                  pName === "/dashboard/fixed-url" ||
                    pName === "/dashboard/track-url"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a
                  href="#urlshortner"
                  data-target="#urlshortner"
                  data-toggle="collapse"
                  className="sidebar-link collapsed"
                >
                  <FontAwesomeIcon icon={faAddressBook} />{" "}
                  <span className="align-middle"> Url Shortner </span>
                </a>
                <ul
                  id="urlshortner"
                  className={
                    pName === "/dashboard/fixed-url" ||
                      pName === "/dashboard/track-url"
                      ? "sidebar-dropdown list-unstyled collapse show"
                      : "sidebar-dropdown list-unstyled collapse"
                  }
                  data-parent="#sidebar"
                >
                  <li
                    className={
                      pName === "/dashboard/fixed-url"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link className="sidebar-link" to="/dashboard/fixed-url">
                      Create Fixed Url
                    </Link>
                  </li>
                  <li
                    className={
                      pName === "/dashboard/track-url"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link className="sidebar-link" to="/dashboard/track-url">
                      Create Track Url
                    </Link>
                  </li>
                </ul>
              </li>

              <li
                className={
                  pName === "/dashboard/fixed-url-report" ||
                    pName === "/dashboard/short-url-report" ||
                    pName === "/dashboard/cta" ||
                    pName === "/dashboard/quick-reply"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a
                  href="#clickreport"
                  data-target="#clickreport"
                  data-toggle="collapse"
                  className="sidebar-link collapsed"
                >
                  <FontAwesomeIcon icon={faAddressBook} />{" "}
                  <span className="align-middle"> Click Report </span>
                </a>
                <ul
                  id="clickreport"
                  className={
                    pName === "/dashboard/fixed-url-report" ||
                      pName === "/dashboard/short-url-report" ||
                      pName === "/dashboard/cta" ||
                      pName === "/dashboard/quick-reply"
                      ? "sidebar-dropdown list-unstyled collapse show"
                      : "sidebar-dropdown list-unstyled collapse"
                  }
                  data-parent="#sidebar"
                >
                  <li
                    className={
                      pName === "/dashboard/fixed-url-report"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/fixed-url-report"
                    >
                      Fixed Url Report
                    </Link>
                  </li>
                  <li
                    className={
                      pName === "/dashboard/short-url-report"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/short-url-report"
                    >
                      Short Url Report
                    </Link>
                  </li>
                  <li
                    className={
                      pName === "/dashboard/cta"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link className="sidebar-link" to="/dashboard/cta">
                      CTA Button Report
                    </Link>
                  </li>
                  <li
                    className={
                      pName === "/dashboard/quick-reply"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link className="sidebar-link" to="/dashboard/quick-reply">
                      Quick Reply Button
                    </Link>
                  </li>
                </ul>
              </li>

              {/* <li
                className={
                  pName === "/dashboard/fixed-url-new" 
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a
                  href="#clickreport"
                  data-target="#clickreport"
                  data-toggle="collapse"
                  className="sidebar-link collapsed"
                >
                  <FontAwesomeIcon icon={faAddressBook} />{" "}
                  <span className="align-middle"> Click Report New </span>
                </a>
                <ul
                  id="clickreport"
                  className={
                    pName === "/dashboard/fixed-url-new" 
                      ? "sidebar-dropdown list-unstyled collapse show"
                      : "sidebar-dropdown list-unstyled collapse"
                  }
                  data-parent="#sidebar"
                >
                  <li
                    className={
                      pName === "/dashboard/fixed-url-new"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/fixed-url-new"
                    >
                      Fixed Url Report New
                    </Link>
                  </li>
                </ul>
              </li> */}

              <li
                className={
                  pName === "/dashboard/whatsapp-optin-otpout"
                    ? "sidebar-item active"
                    : "sidebar-item "
                }
              >
                <NavLink
                  className="sidebar-link"
                  isActive={checkActive}
                  to="/dashboard/whatsapp-gallery"
                >
                  <FontAwesomeIcon icon={faImage} />{" "}
                  <span className="align-middle">Media Gallery</span>
                </NavLink>
              </li>

              {fb_menu && (
                <li
                  className={
                    pName === "/dashboard/create-new-fallback" ||
                      pName === "/dashboard/fallback-list"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a
                    href="#Event"
                    data-target="#Event"
                    data-toggle="collapse"
                    className="sidebar-link collapsed"
                  >
                    <img
                      className="dashboardIcons"
                      alt="icons"
                      src={fallbackIcon}
                    />{" "}
                    <span className="align-middle"> Fallback </span>
                  </a>
                  <ul
                    id="Event"
                    className={
                      pName === "/dashboard/create-new-fallback" ||
                        pName === "/dashboard/fallback-list"
                        ? "sidebar-dropdown list-unstyled collapse show"
                        : "sidebar-dropdown list-unstyled collapse"
                    }
                    data-parent="#sidebar"
                  >
                    <li
                      className={
                        pName === "/dashboard/create-new-fallback"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/create-new-fallback"
                      >
                        Create Fallback{" "}
                      </Link>
                    </li>
                    <li
                      className={
                        pName === "/dashboard/fallback-list"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/fallback-list"
                      >
                        View Fallback
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              <li
                className={
                  pName === "/dashboard/reports"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <Link className="sidebar-link" to="/dashboard/reports">
                  <img
                    className="dashboardIcons"
                    alt="icons"
                    src={analyticsIcon}
                  />{" "}
                  <span className="align-middle">Analytics</span>
                </Link>
              </li>

              {userID === 6737 && (
              <li
                className={
                  pName === "/dashboard/template"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <NavLink
                  className="sidebar-link"
                  isActive={checkActive}
                  to="/dashboard/template"
                >
                  <FontAwesomeIcon icon={faFileAlt} />{" "}
                  <span className="align-middle">Templates</span>
                </NavLink>
              </li>
              )}

              <li
                className={
                  pName === "/dashboard/configure-webhook" ||
                    pName === "/dashboard/webhook-report" ||
                    pName === "/dashboard/shopify-webhook"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a
                  href="#hook"
                  data-target="#hook"
                  data-toggle="collapse"
                  className="sidebar-link collapsed"
                >
                  <FontAwesomeIcon icon={faAtom} />{" "}
                  <span className="align-middle"> Webhook </span>
                </a>
                <ul
                  id="hook"
                  className={
                    pName === "/dashboard/configure-webhook" ||
                      pName === "/dashboard/webhook-report" ||
                      pName === "/dashboard/shopify-webhook"
                      ? "sidebar-dropdown list-unstyled collapse show"
                      : "sidebar-dropdown list-unstyled collapse"
                  }
                  data-parent="#sidebar"
                >
                  <li
                    className={
                      pName === "/dashboard/configure-webhook"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/configure-webhook"
                    >
                      Configure Webhook{" "}
                    </Link>
                  </li>
                  <li
                    className={
                      pName === "/dashboard/webhook-report"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/webhook-report"
                    >
                      Webhook Report
                    </Link>
                  </li>
                </ul>
              </li>

              <li
                className={
                  pName === "/dashboard/configure-integration" ||
                    pName === "/dashboard/workflow" ||
                    pName === "/dashboard/workflow-list"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a
                  href="#integration"
                  data-target="#integration"
                  data-toggle="collapse"
                  className="sidebar-link collapsed"
                >
                  <FontAwesomeIcon icon={faLink} />{" "}
                  <span className="align-middle"> Integration </span>
                </a>
                <ul
                  id="integration"
                  className={
                    pName === "/dashboard/configure-integration" ||
                      pName === "/dashboard/workflow" ||
                      pName === "/dashboard/workflow-list"
                      ? "sidebar-dropdown list-unstyled collapse show"
                      : "sidebar-dropdown list-unstyled collapse"
                  }
                  data-parent="#sidebar"
                >
                  <li
                    className={
                      pName === "/dashboard/configure-integration"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/configure-integration"
                    >
                      Configure Integration{" "}
                    </Link>
                  </li>

                  {(userID === 6737 || userID === 14787 || userID === 8548) && (
                    <li
                      className={
                        pName === "/dashboard/workflow-list"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/dashboard/workflow-list"
                      >
                        Webhook Integration{" "}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>

              <li
                className={
                  pName === "/dashboard/my-profile" ||
                   pName === "/dashboard/my-plans" ||
                    pName === "/dashboard/change-password"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a
                  href="#ui"
                  data-target="#ui"
                  data-toggle="collapse"
                  className="sidebar-link collapsed"
                >
                  <FontAwesomeIcon icon={faUser} />{" "}
                  <span className="align-middle">My Account</span>
                </a>
                <ul
                  id="ui"
                  className={
                    pName === "/dashboard/my-profile" ||
                     pName === "/dashboard/my-plans" ||
                      pName === "/dashboard/change-password" ||
                      pName === "/dashboard/transaction-payment" ||
                      pName === "/dashboard/notification" ||
                      pName === "/dashboard/transaction-history" ||
                      pName === "/dashboard/billing" ||
                      pName === "/dashboard/two-factor-authentication"
                      ? "sidebar-dropdown list-unstyled collapse show"
                      : "sidebar-dropdown list-unstyled collapse"
                  }
                  data-parent="#sidebar"
                >
                  <li
                    className={
                      pName === "/dashboard/my-profile"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link className="sidebar-link" to="/dashboard/my-profile">
                      Profile
                    </Link>
                  </li>

                   <li
                    className={
                      pName === "/dashboard/my-plans"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link className="sidebar-link" to="/dashboard/my-plans">
                      My Plans
                    </Link>
                  </li>

                  <li
                    className={
                      pName === "/dashboard/transaction-history"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/transaction-history"
                    >
                      {" "}
                      Transaction History{" "}
                    </Link>
                  </li>

                  <li
                    className={
                      pName === "/dashboard/price-list"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link className="sidebar-link" to="/dashboard/price-list">
                      {" "}
                      My Price List{" "}
                    </Link>
                  </li>

                  <li
                    className={
                      pName === "/dashboard/change-password"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/change-password"
                    >
                      Change Password
                    </Link>
                  </li>
                  <li
                    className={
                      pName === "/dashboard/two-factor-authentication"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <Link
                      className="sidebar-link"
                      to="/dashboard/two-factor-authentication"
                    >
                      Two-Factor Authentication
                    </Link>
                  </li>

                  {checkUserUrl(url) && (
                    <>
                      <li
                        className={
                          pName === "/dashboard/notification"
                            ? "sidebar-item active"
                            : "sidebar-item"
                        }
                      >
                        <Link
                          className="sidebar-link"
                          to="/dashboard/notification"
                        >
                          {" "}
                          Notification Setup{" "}
                        </Link>
                      </li>
                      {parent_type !== "reseller" && (
                        <li
                          className={
                            pName === "/dashboard/transaction-payment"
                              ? "sidebar-item active"
                              : "sidebar-item"
                          }
                        >
                          <Link
                            className="sidebar-link"
                            to="/dashboard/transaction-payment"
                          >
                            Recharge
                          </Link>
                        </li>
                      )}
                    </>
                  )}
                </ul>
              </li>
              <li
                className={
                  pName === "/dashboard/EmailVerification"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
              </li>
              {checkUserUrl(url) && (
                <>
                  <li
                    className={
                      pName === "/dashboard/support" ||
                        pName === "/dashboard/create-new-ticket" ||
                        pName === "/dashboard/ticket"
                        ? "sidebar-item active"
                        : "sidebar-item"
                    }
                  >
                    <a className="sidebar-link" href="/dashboard/support">
                      <img
                        className="dashboardIcons"
                        alt="icons"
                        src={phoneIcon}
                      />{" "}
                      <span className="align-middle">Support</span>
                    </a>
                  </li>
                </>
              )}

              <li
                className={
                  pName === "/dashboard/download-centre"
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
              >
                <a className="sidebar-link" href="/dashboard/download-centre">
                  <FontAwesomeIcon icon={faDownload} />{" "}
                  <span className="align-middle">Download Centre</span>
                </a>
              </li>

              {checkUserUrl(url) && (
                <li
                  className={
                    pName === "/dashboard/marketplace"
                      ? "sidebar-item active"
                      : "sidebar-item"
                  }
                >
                  <a className="sidebar-link" href="/dashboard/marketplace">
                    <FontAwesomeIcon icon={faBriefcase} />{" "}
                    <span className="align-middle">Marketplace</span>
                  </a>
                </li>
              )}

              <hr className="m-0" />
              <br />
              <br />
              <br />
              <div className="sidebar-link">
                <div
                  data-toggle="modal"
                  data-target="#exampleModalCenter"
                  className="feedback-bg"
                >
                  <img src={feedbackImg} />
                  <p>Help Us Make better</p>
                  <button
                    type="button"
                    className="btn btn-primary border-0 btn-sm"
                  >
                    {" "}
                    Share Feedback{" "}
                  </button>
                </div>
              </div>
            </ul>
          </div>
        </div >
      </nav >
      {showWidgetPopup && (
        <div
          onClick={() => setShowWidgetPopup(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.6)", backdropFilter: "blur(4px)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: "20px", maxWidth: "380px", width: "90%", boxShadow: "0 24px 60px rgba(0,0,0,0.22)", overflow: "hidden", position: "relative" }}
          >
            {/* Close */}
            <button
              onClick={() => setShowWidgetPopup(false)}
              style={{ position: "absolute", top: "14px", right: "14px", background: "rgba(255,255,255,0.2)", border: "none", borderRadius: "50%", width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 1 }}
            >
              <FiX size={16} color="#fff" />
            </button>

            {/* Header */}
            <div style={{ background: "linear-gradient(135deg, #6f42c1 0%, #4f46e5 100%)", padding: "36px 28px 28px", textAlign: "center" }}>
              <div style={{ width: "64px", height: "64px", background: "rgba(255,255,255,0.2)", borderRadius: "18px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
                <FiBarChart2 size={32} color="#fff" />
              </div>
              <h5 style={{ color: "#fff", fontWeight: "800", fontSize: "18px", margin: "0 0 6px" }}>Widget Analytics</h5>
              <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: "10px", fontWeight: "700", letterSpacing: "1px", borderRadius: "20px", padding: "3px 10px" }}>
                <FiLock size={9} /> PRO ADD-ON
              </span>
            </div>

            {/* Body */}
            <div style={{ padding: "24px 28px 28px" }}>
              <p style={{ color: "#6b7280", fontSize: "13px", marginBottom: "18px", lineHeight: "1.6" }}>
                Unlock powerful insights into your widget performance and user engagement with the Widget Analytics add-on.
              </p>

              <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "24px" }}>
                {["Real-time widget performance", "User interaction tracking", "Conversion & click analytics", "Detailed engagement reports"].map((f) => (
                  <div key={f} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{ width: "22px", height: "22px", background: "#ede9fe", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <FiCheck size={12} color="#6f42c1" />
                    </div>
                    <span style={{ fontSize: "13px", color: "#374151", fontWeight: "500" }}>{f}</span>
                  </div>
                ))}
              </div>

              <Link
                to={{ pathname: "/dashboard/whatsapp-widget-steps/:id", state: { initialStep: 2 } }}
                onClick={() => setShowWidgetPopup(false)}
                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", background: "linear-gradient(135deg, #6f42c1 0%, #4f46e5 100%)", color: "#fff", borderRadius: "10px", padding: "12px", fontWeight: "700", fontSize: "14px", textDecoration: "none", boxShadow: "0 4px 14px rgba(111,66,193,0.35)" }}
              >
                <FiZap size={15} />
                Upgrade to PRO
              </Link>
            </div>
          </div>
        </div>
      )}
      <ChooseCampaign />
    </>
  );
};

export default DashboardLeftMenu;
